import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameItemDescription = paths['/v4/game/{slug}/descr/'];

const getGameItemDescription = createRequest<GameItemDescription>('/pc/v4/game/{slug}/descr/');

export default getGameItemDescription;
